import { ProfileInfo } from '@/features/profile/ProfileInfo'
import { Page, Text } from '@/ui-kit'

const ProfilePage = () => {
  return (
    <Page>
      <Text type="h4" className="py-8">
        Profile
      </Text>
      <ProfileInfo />
    </Page>
  )
}

export default ProfilePage
